import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DomainConstants from "../../constants/DomainConstants";

import AutoBindComponent from "../common/AutoBindComponent";
import * as mijnDossierActions from "../../actions/mijnDossierActions";
import * as schaduwDossierActions from "../../actions/schaduwDossierActions";
import * as layoutActions from "../../actions/layoutActions";
import * as documentActions from "../../actions/documentActions";
import * as queryString from "query-string";
import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import DossierForm from "./DossierForm";
import DossierPageHelper from "./DossierPageHelper";
const editPageUrl = "aanvraag/";
const rapportPageUrl = "voortgangsrapport/project/";
import showToastr, { showToastrInfo, showToastrError, showToastrSuccess } from "../../util/toastr.js";

const routePrefix = "/document/";

class DossierPage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			documenten: []
		};

		this.pageHelper = new DossierPageHelper(this);
	}

	componentWillMount() {
		this.pageHelper.init();
	}

	componentWillUpdate(nextProps) {
		this.pageHelper.update(nextProps);
	}

	render() {

		let mijnDossier = this.props.mijnDossier;
		if (mijnDossier && this.props.refAlgemeneStatussen) {
			const needToRedirect = mijnDossier.urlVoorAanvraagronde != null;

			const schaduwDossierBeoordeeld = [121450002, 121450003, 121450004];
			if (this.props.schaduwdossier && schaduwDossierBeoordeeld.indexOf(this.props.schaduwdossier.algemeneStatus) >= 0)
				mijnDossier = this.props.schaduwdossier;

			const serviceUrl = prependRoot(routePrefix, getApiRoot());
			const editPageUrlForDossier = needToRedirect ? mijnDossier.urlVoorAanvraagronde + '/' + editPageUrl + mijnDossier.dossierId : editPageUrl + mijnDossier.dossierId;
			const pdfUrlForDossier = mijnDossier.pdfBeschikbaar ? serviceUrl + mijnDossier.dossierId + "/pdf" : null;
			const nieuwRapportUrl = this.props.schaduwdossier ? this.props.schaduwdossier.rapporteringMogelijk ? rapportPageUrl + "nieuw/" + this.props.schaduwdossier.dossierId : null : this.props.mijnDossier ? this.props.mijnDossier.rapporteringMogelijk ? rapportPageUrl + "nieuw/" + this.props.mijnDossier.dossierId : null : null;
			const dossierNaam = mijnDossier.naam;
			const dossierStatus = this.props.schaduwdossier ? this.props.refAlgemeneStatussen[this.props.schaduwdossier.algemeneStatus] : this.props.refAlgemeneStatussen[this.props.mijnDossier.algemeneStatus];



			return (
				<div>
					<DossierForm
						dossierNaam={dossierNaam}
						dossierStatus={dossierStatus}
						editPageUrl={editPageUrlForDossier}
						pdfUrl={pdfUrlForDossier}
						voortgangsrapporten={this.props.mijnDossier.voortgangsrapporten}
						rapporteringMogelijk={this.props.schaduwdossier ? this.props.schaduwdossier.rapporteringMogelijk : this.props.mijnDossier.rapporteringMogelijk}
						deadlineVoortgangsrapport={this.props.mijnDossier.deadlineVoortgangsrapport}
						nieuwRapportUrl={nieuwRapportUrl}
						rapportUrl={rapportPageUrl}
						documentUrl={serviceUrl}
						dossier={this.props.schaduwdossier ? this.props.schaduwdossier : this.props.mijnDossier}
						documenten={this.state.documenten}
						needToRedirect={needToRedirect}
					/>
				</div>
			);
		}
		else
			return null;
	}
}

DossierPage.propTypes = {
	mijnDossier: PropTypes.object
};

function mapStateToProps(state, ownProps) {

	return {
		mijnDossier: state.mijnDossier,
		schaduwdossier: state.schaduwDossier.model,
		finishedLoadingSchaduwDossier: state.schaduwDossier.finishedLoading,
		refAlgemeneStatussen: state.referentie.algemeneStatussen
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		loadMijnDossier: bindActionCreators(mijnDossierActions.loadMijnDossier, dispatch),
		loadLayout: bindActionCreators(layoutActions.loadMijnDossierPageLayout, dispatch),
		getContent: bindActionCreators(documentActions.getContent, dispatch),
		loadSchaduwdossier: bindActionCreators(schaduwDossierActions.loadSchaduwdossier, dispatch),
		schaduwdossierResetFinishedLoading: bindActionCreators(schaduwDossierActions.schaduwdossierResetFinishedLoading, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(DossierPage);
